export function isRecaptchaDisabled() {
  return process.env.VUE_APP_DISABLE_RECAPTCHA === "true";
}
